import { g as get } from "./api.js";
import { c as currentCustomer } from "./customer.js";
import { S as Sleep } from "./sleep.js";
let customerUUID;
currentCustomer.subscribe((val) => {
  if (val && typeof val.uuid !== "undefined") {
    customerUUID = val.uuid;
  }
});
const availableProjectLeaders = async () => {
  if (typeof customerUUID === "undefined") {
    await Sleep(1e3);
  }
  return await get("/associates/customer/" + customerUUID);
};
const searchCustomers = async (search) => {
  return await get("/customers?order=registry&search=" + search);
};
const fullCustomer = async (customerUUID2) => {
  return await get("/customer/" + customerUUID2);
};
export {
  availableProjectLeaders as a,
  fullCustomer as f,
  searchCustomers as s
};
//# sourceMappingURL=customer2.js.map
